import App from "./Empresa.svelte";
const initConfig = {
    mainTitle: "Customize your Accora FloorBed",
    bookADemoHref: "https://accora.care/book-a-join-visit",
};
export const EmpresaConfigurator = (targetId, config) => {
    const app = new App({
        target: document.getElementById(targetId),
        props: {
            config: Object.assign(Object.assign({}, initConfig), config),
        },
    });
    return app;
};
window.EmpresaConfigurator = EmpresaConfigurator;
export default EmpresaConfigurator;
